import React, { useEffect } from 'react'

import { RouteComponentProps } from 'react-router'
import { parse } from 'query-string'

import { ResultContextProvider } from 'src/context/results'
import { ResultsList, ResultsHeader } from 'src/refactor/blocks'
import { SearchParams } from 'src/api/types'
import { MapProvider } from 'react-map-gl'

export const Results: React.FC<RouteComponentProps> = ({ location }) => {
  const initialParams = parse(location.search) as Record<
    keyof SearchParams,
    string | string[]
  >

  useEffect(() => {
    document.title = 'Centivo Provider Search - Results page'
    document.getElementById('aria-field')?.focus()
    const paginationUl = document.querySelector('.pagination-container ul')

    if (paginationUl) paginationUl.removeAttribute('role')
  }, [])

  return (
    <ResultContextProvider initialParams={initialParams}>
      <MapProvider>
        <ResultsHeader />
        <ResultsList />
      </MapProvider>
    </ResultContextProvider>
  )
}
